import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  getCompactMultiSelectMaxTagCount,
  getCompactMultiSelectPlaceholder,
} from '../../../utils/compactMultiSelect';

const WorkflowFilter = ({
  updateQuery,
  selectedWorkflows,
  setSelectedWorkflows,
}) => {
  const [workflows, setWorkflows] = useState([]);

  useEffect(() => {
    getWorkflows();
  }, []);

  const getWorkflows = () => {
    axios.get('/api/v1/outbound_call_workflows').then((response) => {
      setWorkflows(response.data.data || []);
    });
  };
  const handleWorkflowChange = (value) => {
    setSelectedWorkflows(value);
    updateQuery({ workflows: value });
  }

  return (
    <Select
      className='voice-outbound-subheader-select compact-multi-select'
      mode='multiple'
      placeholder='Workflow'
      value={selectedWorkflows}
      allowClear={true}
      onClear={() => handleWorkflowChange([])}
      options={
        workflows.map((workflow) => {
          const displayName = workflow.display_name || workflow.name;

          return {
            label: displayName,
            value: displayName,
          };
        }) || []
      }
      onChange={(value) => handleWorkflowChange(value)}
      style={{ minWidth: '140px' }}
      maxTagCount={getCompactMultiSelectMaxTagCount(selectedWorkflows)}
      maxTagPlaceholder={getCompactMultiSelectPlaceholder('workflows')}
    />
  );
};

WorkflowFilter.defaultProps = {
  updateQuery: () => {},
  selectedWorkflows: [],
  setSelectedWorkflows: () => {},
}

WorkflowFilter.propTypes = {
  updateQuery: PropTypes.func,
  selectedWorkflows: PropTypes.array,
  setSelectedWorkflows: PropTypes.func,
}

export default withRouter(WorkflowFilter);
